import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import loggin from "../assets/Login/login.png";
import logo from "../assets/Login/aliklogo.png";
import { FaLock, FaEnvelope, FaUser, FaMobile } from "react-icons/fa";

function RetailSignup() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const passwordInputRef = useRef(null);
    const navigate = useNavigate();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        // Push a new state to the history stack when the component mounts
        window.history.pushState(null, null, window.location.pathname);

        // Add a listener to the 'popstate' event
        window.addEventListener("popstate", handlePopstate);

        // Clean up the listener when the component unmounts
        return () => {
            window.removeEventListener("popstate", handlePopstate);
        };
    }, []);

    const handlePopstate = () => {
        // Push another state to the history stack, effectively preventing the user from going back
        window.history.pushState(null, null, window.location.pathname);
    };

    const handleSignup = async (event) => {
        event.preventDefault();

        if (!validateMobileNumber(mobile)) {
            alert("Please enter a 10-digit mobile number.");
            return;
        }

        // Create an object with the form data
        const formData = {
            firstName,
            lastName,
            email,
            mobile,
            username,
            password,
        };

        // Wrap the form data object in an array
        const requestData = [formData];

        console.log("Request Body:", JSON.stringify(requestData));

        // Make the signup API call
        fetch(`${apiBaseUrl}/user/SignUp/JAPAN_ACCESORIES`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((data) => {
                // Handle the response from the signup API
                console.log(data);
                // Reset the form fields
                setFirstName("");
                setLastName("");
                setEmail("");
                setMobile("");
                setUsername("");
                setPassword("");

                // Show a success message to the user
                if (data === 1) {
                    alert("Form submitted successfully!");

                    // console.log("username:",username);
                    // console.log("password:",password);

                    // Construct the login URL with the username and password as query parameters
                    const loginURL = `${apiBaseUrl}/user/SignIn/JAPAN_ACCESORIES?username=${encodeURIComponent(
                        username
                    )}&password=${encodeURIComponent(password)}`;

                    // Prepare the login request body including the Ledname
                    const loginData = {
                        Ledname: firstName + " " + lastName,
                    };

                    // Make the login API call
                    fetch(loginURL, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(loginData),
                    })
                        .then((response) => response.json())
                        .then((loginResponse) => {
                            // Handle the response from the login API
                            console.log(loginResponse);
                            // Show a success message to the user
                            if (loginResponse.success) {
                                alert("Login successful!");
                                // Redirect the user to the dashboard or home page
                                navigate("/");
                            } else {
                                alert("Login failed.");
                            }
                        })

                        .catch((error) => {
                            // Handle any errors
                            console.error("Error:", error);
                            //   // Show an error message to the user
                            //   alert(
                            //     "An error occurred while logging in. Please try again later."
                            //   );
                        });

                    // console.log("username1:",username);
                    // console.log("password1:",password);

                    // In the component where you navigate to the Otp component
                    navigate("/Otp", { state: { username, password } });
                } else if (data === 0) {
                    alert("Already registered.");
                } else {
                    alert("Registration failed.");
                }
            })
            .catch((error) => {
                // Handle any errors
                console.error("Error:", error);
                // Show an error message to the user
                alert("An error occurred while submitting the form. Please try again later.");
            });
    };

    // const validateEmail = (email) => {
    //   // Regular expression for email validation
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // };

    const validateMobileNumber = (mobileNumber) => {
        // Regular expression for 10-digit number validation
        const mobileNumberRegex = /^\d{10}$/;
        return mobileNumberRegex.test(mobileNumber);
    };

    const validatePinCode = (pinCode) => {
        // Regular expression for 6-digit number validation
        const pinCodeRegex = /^\d{6}$/;
        return pinCodeRegex.test(pinCode);
    };

    const home = async () => {
        navigate("/");
    };
    const login = async () => {
        navigate("/login");
    };

    return (
        <div className="min-h-screen  flex justify-center items-center bg-[#F7F7F7]">
            <div className="flex flex-row  bg-white w-[100%] h-[100vh]  bg-[white]">
                <div className="flex flex-col  w-[100%] md:py-2 lg:py-4  lg:w-[50%] h-[100%] bg-[white]">
                    <div className="flex justify-center items-center w-full h-[90%] md:my-6">
                        <div className="flex flex-col w-[90%] md:w-[75%] h-[80%] gap-4 md:gap-6 ">
                            <div className="flex flex-col mx-10">
                                <div className="flex flex-col sm:flex-row md:mb-4">
                                    <h2 className="text-2xl font-bold text-black mr-2">Sign up </h2>
                                    <h2 className="sm:text-2xl font-bold text-black">to access all features</h2>
                                </div>

                                <div className="flex flex-col sm:flex-row mb-2 md:mb-4">
                                    <p className="text-gray-400 text-[#d1d5db] mr-2">Create an account </p>
                                    <p className="text-gray-400 text-[#d1d5db]"> to start your journey</p>
                                </div>

                                {/* Username Field */}
                                <div className="flex flex-col sm:flex-row gap-4 mb-4">
                                    <div className="relative w-full">
                                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                            <FaUser className="text-[#8b0000]" />
                                        </span>
                                        <input
                                            type="text"
                                            placeholder="Firstname"
                                            className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            onChange={(e) => setFirstName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="relative w-full">
                                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                            <FaUser className="text-[#8b0000]" />
                                        </span>
                                        <input
                                            type="text"
                                            placeholder="Lastname"
                                            className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                            onChange={(e) => setLastName(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Email Field */}
                                <div className="relative mb-4">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaEnvelope className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="email"
                                        placeholder="Email"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Mobile Field */}
                                <div className="relative mb-4">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaMobile className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="tel"
                                        placeholder="Mobile"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        onChange={(e) => setMobile(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Password Field */}
                                <div className="relative mb-4">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaLock className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                {/* Password Field */}
                                <div className="relative mb-4">
                                    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                                        <FaLock className="text-[#8b0000]" />
                                    </span>
                                    <input
                                        type="password"
                                        placeholder="Confirm Password"
                                        className="w-full pl-10 pr-4 py-3 border border-[#d1d5db] rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div
                                    className="w-[100%] md:h-[14%] h-[10%]  py-3 rounded-[8px] bg-[#8B0000] font-display text-[15px] md:text-[20px] font-[500] text-[white] flex justify-center items-center cursor-pointer"
                                    onClick={handleSignup}
                                >
                                    Signup
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row justify-center items-center gap-2">
                                <span className="font-display text-sm md:text-[18px] font-[300] text-[gray]">
                                    Already have an account?
                                </span>
                                <span
                                    className="font-display text-sm md:text-[18px] font-[600] text-[#2563EB] cursor-pointer "
                                    onClick={login}
                                >
                                    Login to your account
                                </span>
                            </div>
                            <div className="flex flex-col sm:flex-row justify-center items-center gap-2">
                                <span
                                    className="font-display text-sm md:text-[18px] font-[300] text-[#2563EB] cursor-pointer "
                                    onClick={home}
                                >
                                    Access without an account
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" w-[50%] h-[100%] hidden lg:block bg-[#8b0000] rounded-l-[51px]">
                    <img src={loggin} alt="login" className="rounded-l-[51px] h-full mx-auto " />
                </div>
            </div>
        </div>
    );
}

export default RetailSignup;
